<template>
  <div v-if="isNotGroup">
    <span v-if="!hide">
      <v-icon
        style="font-size: 20px"
        color="primary"
        :disabled="!CAN_DELETE(params && params.node ? params.node.data : null)"
        @click.stop="controlClick()"
        >mdi-delete-outline</v-icon
      >
    </span>

    <confirmation
      v-model="confirmDelete"
      :text="params.text || '¿Eliminar el objeto seleccionado?'"
      colorButton="error"
      @confirm="deleteItem()" />
  </div>
</template>

<script>
import Confirmation from '~/components/Confirmation'

export default {
  components: {
    Confirmation,
  },
  data: function () {
    return {
      confirmDelete: false,
    }
  },
  computed: {
    IS_LIST() {
      // console.log('hide', this.params)
      return !this.$route.params.uuid
    },

    isNotGroup() {
      // console.log('hide', this.params)
      return !!(this.params && this.params.data)
    },
    hide() {
      // console.log('hide', this.params)
      return this.params && this.params.value === true
    },
  },
  methods: {
    CAN_DELETE(item) {
      const canDelete = !!(this.$store.state.permisos && this.$store.state.permisos.can_delete)
      const isPrivileged =
        !!this.$store.getters.isAdminGroup || !!this.$store.getters.isAdmin || !!this.$store.getters.isKaam

      // Roles altos: no restringir por empresa en este renderer.
      if (isPrivileged && canDelete) return true
      if (!canDelete) return false

      if (item?.empresa) {
        const itemEmpresaUuid =
          typeof item.empresa === 'object' && item.empresa !== null ? item.empresa.uuid : null
        const userEmpresaUuid =
          this.$store.state.user &&
          this.$store.state.user.empresa &&
          this.$store.state.user.empresa.uuid

        if (!itemEmpresaUuid || !userEmpresaUuid) return false

        return (
          canDelete &&
          itemEmpresaUuid === userEmpresaUuid
        )
      } else {
        return this.$store.getters.isAdminGroup && canDelete
      }
    },
    init() {
      if (this.params.init instanceof Function) this.params.init()
    },
    controlClick() {
      if (this.params.dispatch || this.params.confirm) this.confirmDelete = true
      else this.deleteItem()
    },
    async deleteItem() {
      this.confirmDelete = false
      let gridOptions = this.$parent.gridOptions
      let gridApi = this.$parent.gridOptions.api
      let response = { status: 200 }
      const nodeData = this.params && this.params.node ? this.params.node.data : null
      if (this.params.dispatch && nodeData && nodeData.uuid) {
        response = await this.$store.dispatch(`${this.params.dispatch}`, nodeData)
      }

      // if (response && response.status !== 403) {
      // Eliminamos la row del ag-grid y refrescamos
      const groupedItems = this.params && this.params.node ? this.params.node.allLeafChildren : null
      // if (groupedItems && groupedItems.length) {
      //   for (let i = 0; i < groupedItems.length; i++) {
      //     const row = groupedItems[i]
      //     let indexRow = gridOptions.rowData.indexOf(row.data)
      //     gridOptions.rowData.splice(indexRow, 1)
      //   }
      // } else {
      //   let indexRow = gridOptions.rowData.indexOf(this.params.node.data)
      //   gridOptions.rowData.splice(indexRow, 1)
      // }
      // }

      //TODO: Revisar si es necesario
      this.$router.go()

      gridApi.refreshCells()
      this.init()
    },
  },
}
</script>
